// extracted by mini-css-extract-plugin
export default {"container":"BlockInfo__container--2ue","isTopLine":"BlockInfo__isTopLine--m2p"};